import * as React from 'react';
import { connect } from 'react-redux';
import { DebounceInput } from 'react-debounce-input';

import { GlobalPrivateState, QueryParameterState, addQueryParam, formatMessage, clearQueryParams, removeQueryParam, changeQueryParams } from 'src/api';
import MESSAGES from './SwordSearch.messages';

import './SwordSearch.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { RouterState } from 'connected-react-router';
 
export interface SwordSearchProps {
  dispatch: any;
  queryState: QueryParameterState;
  paramKey?: string;
  location: RouterState['location'];
}

export class SwordSearchPartial extends React.Component<SwordSearchProps, any> {
  
  constructor(props: SwordSearchProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClear = this.handleClear.bind(this);
  }

  public render() {
    const { queryState, paramKey, location } = this.props;
    const key = paramKey || 'sword';
    const value = queryState.params[key] || '';

    return (
      <div className="partial-configuration-search mb-5">
        <form 
          className="form form-search"
          onSubmit={this.handleSubmit}
        >
          <div className="form-row">
            <div className="col-12 col-lg-8 offset-lg-2">
              {value && (
                <button className="form-clear" onClick={this.handleClear}>
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              )}
              <DebounceInput
                className="form-control w-100"
                id="form_search_main"
                type="text"
                value={value}
                placeholder={(location.pathname === '/troughs' ? formatMessage(MESSAGES.SearchPlaceholderTroughs) : formatMessage(MESSAGES.SearchPlaceholder))}
                onChange={this.handleChange}
                disabled={false}
                name="search"
                debounceTimeout={500}
              />
            </div>
            {/* 
            <div className="col-2">
              <button className="btn btn-primary d-block w-100 m-0" type="submit">Search</button>
            </div>
            */}
          </div>
        </form>
      </div>
    );
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>): void {
    const { queryState } = this.props;
    const target = event.target as HTMLInputElement;
    const key = this.props.paramKey || 'sword';
    const sword = target.value || '';

    if (queryState.params.sword !== sword) { 
      if (sword && sword.length > 0) {
        console.log('add sword', sword);
        this.props.dispatch(changeQueryParams({
          ...queryState.params,
          sword
        }));
        // this.props.dispatch(addQueryParam(key, sword));
      } else {
        this.props.dispatch(removeQueryParam(key));
      }
    }
  }
  
  private handleClear(e: any) {
    if (e.detail === 0) { return; }
    this.props.dispatch(removeQueryParam('sword'));
  }
  
  private handleSubmit(event: React.SyntheticEvent<HTMLFormElement>) {
    event.preventDefault();
    return false;
  }
}

export const SwordSearch = connect((state: GlobalPrivateState) => ({
  queryState: state.queryState,
  location: state.router.location
}))(SwordSearchPartial);

export default SwordSearch;
